// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","Clock":"Footer_Clock__RNSkq","HomeFooter":"Footer_HomeFooter__AxAID"};